import styled from 'styled-components';
import { COLORS } from '@/theme';

export const StyledToolbar = styled.div`
  display: flex;
  gap: 1.5rem;
  background: ${COLORS.GRAY_SECONDARY};
  padding: 1rem;
  border-radius: 2rem;

  span {
    transform: scale(1.5);
  }
`;
